<template>
  <div v-loading="loadingtable" class="ruleForm">
    <div style="display: flex;align-items: center;" class="main-box">
      <div>
        <el-form label-position="right" label-width="100px">
          <el-form-item label="部门列表" required="">
            <el-select v-model="query.department_id" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="模版名称" required="">
            <el-input v-model="query.name" placeholder="请输入模板名称" class="stra_box" />
          </el-form-item>
          <el-form-item label="今日内容" required="">
            <el-input v-model="query.today" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入模板内容" maxlength="1000" show-word-limit class="stra_box" @blur="handleInputBlur" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmin">{min}</el-button>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmid">{mid}</el-button>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmax">{max}</el-button>
          </el-form-item>
          <el-form-item label="明日内容" required="">
            <el-input v-model="query.tomorrow" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入模板内容" maxlength="1000" show-word-limit class="stra_box" @blur="handleInputBlurone" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitminone">{min}</el-button>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmidone">{mid}</el-button>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmaxone">{max}</el-button>
          </el-form-item>
          <el-form-item label="其他内容" required="">
            <el-input v-model="query.other" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入模板内容" maxlength="1000" show-word-limit class="stra_box" @blur="handleInputBlurtwo" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmintwo">{min}</el-button>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmidtwo">{mid}</el-button>
            <el-button type="primary" style="margin-right: 10px;" size="mini" @click="addidentifitmaxtwo">{max}</el-button>
          </el-form-item>
          <el-form-item v-show="query.type === 2" label="汇报日期" required="">
            <el-radio-group v-model="query.corn_day">
              <el-radio v-for="(day, index) in daysOfWeek" :key="index" :label="day.value">{{ day.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="汇报时间" required="">
        <el-time-select
          v-model="query.corn_time"
          :picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:45'
          }"
          placeholder="选择时间"
        >
        </el-time-select>
      </el-form-item> -->
        </el-form>
      </div>
      <div style="margin-left: 100px;">
        <div class="tenw_box">文本占位符</div>
        <div class="tenw_box">
          <el-tag type="success">{min}：1~9</el-tag>
        </div>
        <div class="tenw_box">
          <el-tag type="success">{mid}：10~99</el-tag>
        </div>
        <div>
          <el-tag type="success">{max}：100~999</el-tag>
        </div>
      </div>
    </div>
    <div class="sava_box">
      <el-button type="primary" @click="goback">返回</el-button>
      <el-button type="warning" :disabled="loadingtable" @click="saveclick">保存</el-button>
    </div>
  </div>
</template>

<script>
// import relevaceTime from './relevaceTime.vue'
import { createReportRules, updateReportRules, spReportdepartmentList } from '@/api/tencentAccountIni'

export default {
  // components: {
  //   relevaceTime
  // },
  data() {
    return {
      loadingtable: false,
      isEdited: false,
      query: {
        type: null, // 判断是1日报、2周报还是3月报
        name: null,
        today: '',
        tomorrow: '',
        other: '',
        corn_day: 0, // 周报必填，其他都传0
        // corn_time: null,
        department_id: null
      },
      daysOfWeek: [
        { value: 1, label: '周一' },
        { value: 2, label: '周二' },
        { value: 3, label: '周三' },
        { value: 4, label: '周四' },
        { value: 5, label: '周五' },
        { value: 6, label: '周六' },
        { value: 0, label: '周日' }
      ],
      options: [],
      blurIndexmin: null,
      addtifitmin: '{min}',
      // blurIndexmid: null,
      addtifitmid: '{mid}',
      addtifitmax: '{max}',
      blurIndex: null,
      blurIndextwo: null
    }
  },
  created() {
    this.list()
    // 判断是新增还是编辑
    const { id } = this.$route.query
    this.query.id = id
    this.isEdited = !!id
    // 1日报2周报3月报
    const { type } = this.$route.query
    this.query.type = type
    const { row } = this.$route.query
    if (row) {
      this.query = row
    }
    console.log('row', row)
  },
  methods: {
    async list() {
      const data = await spReportdepartmentList()
      this.options = data.data
      console.log('data', data)
    },
    goback() {
      this.$router.go(-1)
    },
    async saveclick() {
      if (!this.query.department_id) {
        this.$message({
          message: '请选择部门',
          type: 'error'
        })
        return
      }
      if (!this.query.name) {
        this.$message({
          message: '请输入模版名称',
          type: 'error'
        })
        return
      }
      if (!this.query.today) {
        this.$message({
          message: '请输入今日模板内容',
          type: 'error'
        })
        return
      }
      // if (!this.query.tomorrow) {
      //   this.$message({
      //     message: '请输入明日模板内容',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (!this.query.other) {
      //   this.$message({
      //     message: '请输入其他模板内容',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (!this.query.corn_time) {
      //   this.$message({
      //     message: '请选择汇报时间',
      //     type: 'error'
      //   })
      //   return
      // }

      if (this.isEdited) {
        try {
          await updateReportRules(this.query)
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.$router.go(-1)
        } catch (error) {
          this.$message({
            message: '更新失败',
            type: 'error'
          })
          this.$router.go(-1)
        }
      } else {
        try {
          await createReportRules(this.query)
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.go(-1)
        } catch (error) {
          this.$message({
            message: '创建失败',
            type: 'error'
          })
          this.$router.go(-1)
        }
      }
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndexmin = e.srcElement.selectionStart
    },
    addidentifitmin() {
      this.query.today = this.query.today.slice(0, this.blurIndexmin) + this.addtifitmin + this.query.today.slice(this.blurIndexmin)
    },
    addidentifitmid() {
      this.query.today = this.query.today.slice(0, this.blurIndexmin) + this.addtifitmid + this.query.today.slice(this.blurIndexmin)
    },
    addidentifitmax() {
      this.query.today = this.query.today.slice(0, this.blurIndexmin) + this.addtifitmax + this.query.today.slice(this.blurIndexmin)
    },
    handleInputBlurone(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    addidentifitminone() {
      this.query.tomorrow = this.query.tomorrow.slice(0, this.blurIndex) + this.addtifitmin + this.query.tomorrow.slice(this.blurIndex)
    },
    addidentifitmidone() {
      this.query.tomorrow = this.query.tomorrow.slice(0, this.blurIndex) + this.addtifitmid + this.query.tomorrow.slice(this.blurIndex)
    },
    addidentifitmaxone() {
      this.query.tomorrow = this.query.tomorrow.slice(0, this.blurIndex) + this.addtifitmax + this.query.tomorrow.slice(this.blurIndex)
    },
    handleInputBlurtwo(e) {
      this.blurIndextwo = e.srcElement.selectionStart
    },
    addidentifitmintwo() {
      this.query.other = this.query.other.slice(0, this.blurIndextwo) + this.addtifitmin + this.query.other.slice(this.blurIndextwo)
    },
    addidentifitmidtwo() {
      this.query.other = this.query.other.slice(0, this.blurIndextwo) + this.addtifitmid + this.query.other.slice(this.blurIndextwo)
    },
    addidentifitmaxtwo() {
      this.query.other = this.query.other.slice(0, this.blurIndextwo) + this.addtifitmax + this.query.other.slice(this.blurIndextwo)
    }
  }
}
</script>

<style>
.ruleForm {
  margin-top: 50px;
  margin-left: 30px;
}
.stra_box {
  width: 500px;
}
.ruletypes {
  display: flex;
}
.cardrule {
  border: 1px solid #bdc0c5;
  width: 250px;
  height: 100px;
  border-radius: 5px;
  padding: 10px;
  margin-right: 10px;
}
.active {
  background-color: #e7f4ff;
  border: 1px solid #0082f0;
}
.typerule {
  font-weight: 600;
  font-size: 14px;
  margin-right: 5px;
}
.description {
  display: block;
  font-size: 12px;
  color: #606266;
  height: 16px;
  line-height: 16px;
}
.addbutton {
  margin-bottom: 10px;
}
.sava_box {
  position: fixed;
  bottom: 10px;
  left: 286px;
}
.tenw_box{
  margin-bottom: 10px;
}
@media (max-width: 768px){
  /* flex-direction: column */
  .ruleForm{
    margin-left:0px;
  }
  .main-box{
    flex-direction:column;
  }
}
</style>
